export const PROD_ADVISOR_DOMAIN = "advisor.findfaye.com";
export const PROD_MEMBER_DOMAIN = "app.findfaye.com";
